module.exports = __webpack_public_path__ + "static/media/Upgradeproperty.ae29f4d4.svg";